import { AlertMessage } from '../AlertMessage';

function ErrorFallback({ error }) {
  return <AlertMessage message={error.message} />;
}

export default ErrorFallback;
